import { render, staticRenderFns } from "./LeashSizeSelect.vue?vue&type=template&id=5868a0cc&scoped=true&"
import script from "./LeashSizeSelect.vue?vue&type=script&lang=js&"
export * from "./LeashSizeSelect.vue?vue&type=script&lang=js&"
import style0 from "./LeashSizeSelect.vue?vue&type=style&index=0&id=5868a0cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5868a0cc",
  null
  
)

export default component.exports